import { render, staticRenderFns } from "./ColonizationNotif.vue?vue&type=template&id=37284ff9&"
import script from "./ColonizationNotif.vue?vue&type=script&lang=js&"
export * from "./ColonizationNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports